import { createRouter, createWebHashHistory } from 'vue-router';

const Landing = () => import(/* webpackChunkName: "landing" */ '../components/Landing.vue');
const GameBoard = () => import(/* webpackChunkName: "game" */ '../components/game/GameBoard.vue');
const CreateGame = () => import(/* webpackChunkName: "lobby" */ '../components/lobby/CreateGame.vue');
const JoinGame = () => import(/* webpackChunkName: "lobby" */ '../components/lobby/JoinGame.vue');

// Route names match thunderstone's own router exactly (Matt: "look to how
// we did it for Thunderstone... a similar pattern") - /game stays local
// (hotseat / solo-vs-AI), /game/:gameId is the same GameBoard.vue component
// but bound to a remote Firebase-synced game via its gameId prop.
const routes = [
  { path: '/', name: 'landing', component: Landing },
  { path: '/game', name: 'game', component: GameBoard },
  { path: '/new', name: 'new-remote-game', component: CreateGame },
  { path: '/join/:code?', name: 'join-remote-game', component: JoinGame, props: true },
  { path: '/game/:gameId', name: 'remote-game', component: GameBoard, props: true },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

export default router;
